import RoutesBaseController from '../common/routes.base.controller'

class RoutesallController extends RoutesBaseController {
  /*@ngInject*/
  constructor(Auth, $state, User, Modal, RouteService, $translate, $stateParams, $scope, $q, $location, SetupService, DateUtil) {

    super(Auth, $state, User, RouteService, Modal, $translate, $stateParams, $location)

    this.$q = $q;
    this.SetupService = SetupService;
    this.DateUtil = DateUtil;
    this.id = 'route.all'
    this.loading = false
    this.routes = []
    this.page = 1
    this.total = 0
    this.pageLimit = 10
    this.maxPages = 10
    this.hasACL = {}
    this._status = 'all'
    this.userStatus = [{
      label: 'All',
      value: 'all'
    },
    {
      label: 'Hold',
      value: 'hold'
    },
    {
      label: 'Regular',
      value: 'regular'
    }
    ]
    this._activeStatus = 'active'
    this.activeStatusList = [{
      label: 'All',
      value: 'all'
    },
    {
      label: 'Active',
      value: 'active'
    },
    {
      label: 'Suspended',
      value: 'suspended'
    }
    ]
    this.searchText = ''
    this.$location = $location
    this.days = [
      { label: this.$translate.instant('location.sun'), value: 'Sun' },
      { label: this.$translate.instant('location.mon'), value: 'Mon' },
      { label: this.$translate.instant('location.tues'), value: 'Tue' },
      { label: this.$translate.instant('location.wed'), value: 'Wed' },
      { label: this.$translate.instant('location.thurs'), value: 'Thu' },
      { label: this.$translate.instant('location.fri'), value: 'Fri' },
      { label: this.$translate.instant('location.sat'), value: 'Sat' },
      { label: this.$translate.instant('location.hol'), value: 'Hol' }
    ];
    this.selectedDay = 'Mon';
    this.loadingRouteSequence = false;
    this.fullList = [];
    this.branch = User.getUser().branchId
    this.valutDate = '';
    this.routeUpdateHistory = {};
    this.uiProcessSection = {};
    this.pagination = {
      page: 1,
      total: 0,
      pageLimit: 10,
      maxPages: 10
    }
    this.pendingRouteChanges = {};
  }

  $onInit() {

    let pageId = this.$stateParams.page
    if (pageId > 0) {
      this.page = pageId
    }

    const dateDefer = this.$q.defer();

    this.SetupService.get(this.branch)
      .then((setup) => {
        const date = this.DateUtil.convertToDate(setup.currentVaultDate);
        dateDefer.resolve(date);
      }).catch((err) => {
        if (err && err.data && err.data.message) {
          this.Modal.errorModal('error.' + err.data.message)
        }
      })

    dateDefer.promise
      .then((date) => {
        this.valutDate = date;
        const today = this.valutDate.getDay();
        this.selectedDay = this.days[today].value;
        return this.loadData();
      })
      .finally(() => {
        this.loading = false;
      });
  }

  edit(route) {
    this.$state.go('routes.edit', ({
      id: route.id,
      day: this.selectedDay
    }))
  }

  delete(route) {
    if (this.allowOnlyOnce) return;
    this.allowOnlyOnce = true;
    this.Modal.confirm({
      header: this.$translate.instant('common.confirm_delete_title'),
      message: this.$translate.instant('common.confirm_delete_message') + ` <strong>${route.id}</strong>?`,
      callback: (({
        modal,
        $scope
      }) => {
        $scope.loading = true
        this.Service.remove(route.id, this.branch)
          .then((data) => {
            this.allowOnlyOnce = false;
            modal.close()
            this.refresh()
          })
          .catch((err) => {
            $scope.isLoading = false;
            $scope.loading = false;
            this.allowOnlyOnce = false;
            if (err && err.data && err.data.message) {
              return this.Modal.errorModal('route.reference_error');
            }
          })
      }),
      negative: (({
        modal,
      }) => {
        this.allowOnlyOnce = false;
        modal.close();
      }),
      type: 'danger'
    })
  }

  refresh() {
    this.loadData()
  }

  pageChange() {
    let newUrl = (window.location.pathname).replace('/' + this.$stateParams.page, '/' + this.page)
    this.$stateParams.page = this.page;
    this.$location.path(newUrl)
    this.loadData()
  }

  search() {
    this.page = 1;
    let newUrl = (window.location.pathname).replace('/' + this.$stateParams.page, '/' + this.page)
    this.$stateParams.page = this.page;
    this.$location.path(newUrl)
    this.loadData()
  }

  generateSearchObj() {
    const searchObj = {
      queryJSON: {
        rules: [{
          field: 'branchId',
          condition: '=',
          data: this.branch
        }],
        operator: 'AND'
      }
    };

    if (this.searchText) {
      const searchFields = ['id', 'name'];
      const trimmedSearchText = this.searchText.trim();
      let searchWords = trimmedSearchText
        .split(/[^a-zA-Z0-9]+/)
        .filter((word) => /[a-zA-Z0-9]/.test(word));

      if (!searchWords.length && trimmedSearchText) {
        searchWords = [trimmedSearchText];
      }

      if (searchWords.length) {
        searchObj.queryJSON.rules.push({
          group: {
            operator: 'AND',
            rules: searchWords.map((word) => ({
              group: {
                operator: 'OR',
                rules: searchFields.map((field) => ({
                  field,
                  condition: 'like',
                  data: `%${word}%`
                }))
              }
            }))
          }
        });
      }
    }

    return searchObj;
  }

  loadData() {
    const searchObj = this.generateSearchObj();

    switch (this._status) {
      case 'hold': {
        searchObj.queryJSON.rules.push({
          field: 'holdRoute',
          condition: '=',
          data: 1
        });
        break;
      }
      case 'regular': {
        searchObj.queryJSON.rules.push({
          field: 'holdRoute',
          condition: '=',
          data: 0
        });
        break;
      }
      case 'all':
      default: {
        break;
      }
    }

    switch (this._activeStatus) {
      case 'active': {
        searchObj.queryJSON.rules.push({
          field: 'active',
          condition: '=',
          data: true
        });
        break;
      }
      case 'suspended': {
        searchObj.queryJSON.rules.push({
          field: 'active',
          condition: '=',
          data: false
        });
        break;
      }
      case 'all': {
        searchObj.includeInactive = true;
        break;
      }
      default: {
        break;
      }
    }

    this.loading = true;
    return this.Service.all(searchObj, (this.page - 1) * this.pageLimit, this.pageLimit)
      .then((data) => {
        this.total = data.total

        this.loading = false
        this.fullList = data.results;
        this.routes = this.fullList.slice()
      })
      .then(() => {
        return this.dayChanged();
      })
      .catch((err) => {
        this.loading = false
        this.error = err.message
      })
  }

  toggleExpand(route) {
    route.expand = !route.expand;
  }

  selectDay(day) {
    this.selectedDay = day.value;
    this.dayChanged();
  }

  dayChanged() {
    this.loadingRouteSequence = true;
    return this.$q.all(
      this.routes.map((route) => {
        this.loadingRouteSequence = true;
        return this.Service.getRouteSequenceCount(route.id, route.branchId, this.selectedDay);
      })
    )
      .then((data) => {
        this.routes.forEach((route, index) => {
          this.loadingRouteSequence = false;
          route.locationsOnRoute = data[index];
        });
      })
      .catch((err) => {
        this.loadingRouteSequence = false;
        console.log(err);
      })
      .finally(() => {
        this.loadingRouteSequence = false;
      });
  }

  setPage(isExpanded, routeId) {
    if (!isExpanded) return;
    this.uiProcessSection[routeId] = { page: 1 }
  }

  getRouteUpdateHistory(isExpanded, routeId) {
    document.getElementById(`expand-btn-${routeId}`).blur();
    if (!isExpanded) return;

    this.uiProcessSection[routeId].process = true;

    this.Service.getRouteUpdateHistory(routeId, this.pagination.pageLimit, (this.uiProcessSection[routeId].page - 1) * this.pagination.pageLimit)
      .then((history) => this.getPendingRouteChanges(routeId).then(pendingChanges => [history, pendingChanges]))
      .then(([history, pendingChanges]) => {
        this.routeUpdateHistory[routeId] = { details: history };
        this.pendingRouteChanges[routeId] = { details: pendingChanges };
        this.routeUpdateHistory[routeId].details.pageLimit = this.pagination.pageLimit;
      })
      .catch((err) => {
        console.log(err);
        if (err && err.data && err.data.message) {
          this.Modal.errorModal(err.data.message);
        }
      })
      .finally(() => {
        this.uiProcessSection[routeId].process = false;
      })
  }

  isArray(key) {
    return Array.isArray(key);
  }

  getPendingRouteChanges(routeId) {
    return this.Service.getPendingRouteChanges(routeId)
      .then((data) => {
        return data;
      })
  }

  translateMessage(key) {
    if (!key) return;
    return this.$translate.instant('route.' + key);
  }
}

export default RoutesallController;



// WEBPACK FOOTER //
// ./client/app/components/routes/all/routes.all.controller.js